module.exports = "<ul>\r\n    <li ng-repeat=\"item in items\" rl-tree-list-2-node-row=\"item\" depth=\"depth\"></li>\r\n</ul>\r\n"